import { createSurveyStyles } from '@sm/webassets';

type styleNames = 'container';
type StyleProps = { premiumCustom: boolean };

const useStyles = createSurveyStyles<styleNames, StyleProps>(theme => {
  return {
    container: ({ premiumCustom }) => ({
      background: premiumCustom ? theme?.primaryBackgroundColor : 'initial',
    }),
  };
});

export default useStyles;
